/**
 * Parse a failed `fetch` response body (FastAPI-style JSON with `detail`, or plain text)
 * into a user-facing string.
 */
export async function parseApiErrorMessage(response: Response): Promise<string> {
  const text = await response.text()
  if (!text.trim()) {
    return `Request failed (${response.status})`
  }
  try {
    const parsed = JSON.parse(text) as { detail?: unknown }
    const { detail } = parsed
    if (typeof detail === 'string') return detail
    if (Array.isArray(detail) && detail.length > 0) {
      const first = detail[0]
      if (typeof first === 'object' && first && 'msg' in first) {
        return String((first as { msg: string }).msg)
      }
      return JSON.stringify(detail)
    }
  } catch {
    // use raw text
  }
  return text
}
